module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Italic.139f40de.ttf";